// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPage_container__hd8cy"};